// extracted by mini-css-extract-plugin
export default {"list":"SearchList_list__nsict","searchList":"SearchList_searchList__3XcgR","searchItem":"SearchList_searchItem__wPEx2"};